import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Typography,
  Radio,
} from "@mui/material";
import {
  setLoading,
  setDialogState,
  resetDialogState,
  setLoginState,
} from "../../redux/features";
import { ReactComponent as EyeOff } from "../../assets/icons/EyeOff.svg";
import { ReactComponent as EyeOn } from "../../assets/icons/EyeOn.svg";
import { UnCheckedIcon, CheckedIcon } from "../../components/CheckBox";
import { ReactComponent as GoogleIcon } from "../../assets/icons/Google.svg";
import TextInput from "../../components/TextInput";
import { useGoogleLogin } from "@react-oauth/google";
import { CloseOutlined } from "@mui/icons-material";
import { ToastMessage } from "../../helpers/ToastMessage";
import Divider from "@mui/material/Divider";
import { useDispatch } from "react-redux";
import { useCookies } from "react-cookie";
import { baseURL } from "../../api/url";
import dayjs from "dayjs";
import * as yup from "yup";
import Axios from "axios";
import { colors } from "../../styles/color";
import {
  fetchProfileDetails,
  setProfileState,
} from "../../redux/features/profile/profileSlice";
import { styled } from "@mui/material/styles";
import { useAppSelector } from "../../hooks/useAppReducer";
import { ApplicationStateType } from "../../redux/store";
import { 
  encrypt, 
  decrypt, 
  storeEncryptedPassword, 
  getEncryptedPassword, 
  removeEncryptedPassword 
} from "../../utils/encryption";

interface FormErrors {
  email?: string;
  password?: string;
}
type props = {
  access_token?: any;
  accesstoken?: any;
};

const LoginModal = () => {
  // const [value, setValue] = React.useState(() => {
  //   // Get saved radio selection from localStorage if remember me was checked
  //   const savedSelection = localStorage.getItem("radioSelectionBusiness");
  //   return savedSelection || "option1";
  // });
  const {
    dialog: { influencerLogin },
  } = useAppSelector((state: ApplicationStateType) => state.dialog);

  // const [value, setValue] = React.useState("option1");
  const [showPassword, setShowPassword] = React.useState(false);
  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const [rememberMeBusiness, setrememberMeBusiness] = useState<any>(
    () => {
      const rememberMeBusiness = localStorage.getItem("rememberMeBusiness");
      console.log("rememberMeBusiness", rememberMeBusiness);
      if(rememberMeBusiness === "true"){
        return true;
      } else if(rememberMeBusiness === "false"){
        return false;
      } else {
        return false;
      }
    }
  );
  const [rememberMeInfluencer, setRememberMeInfluencer] = useState<any>(
    () => {
      const rememberMeInfluencer = localStorage.getItem("rememberMeInfluencer");
      console.log("rememberMeInfluencer", rememberMeInfluencer);
      if(rememberMeInfluencer === "true"){
        return true;
      } else if(rememberMeInfluencer === "false"){
        return false;
      } else {
        return false;
      }
    }
  );
  const [formData, setFormData] = useState(() => {
    // Initialize based on current side and remember me state
    if (influencerLogin) {
      // Influencer side
      const email = localStorage.getItem("emailInfluencer");
      const password = getEncryptedPassword("passwordInfluencer");
      return {
        role: "2",
        email: email || "",
        password: password || "",
      };
    } else {
      // Business side
      const email = localStorage.getItem("emailBusiness");
      const password = getEncryptedPassword("passwordBusiness");
      return {
        role: "3",
        email: email || "",
        password: password || "",
      };
    }
  });
  const [expireTime, setExpireTime] = useState<number | undefined>(30);
  const [accessToken, setAccessToken, removeToken] = useCookies([
    "accessToken",
    "refreshToken",
    "googleToken",
    "role",
    "login",
  ]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = window.location.pathname;
  const pathParts = currentPath.split("/");

  const checkExistingLogin = () => {
    // Check localStorage first (remember me was checked)
    let accessTokenValue = localStorage.getItem("accessToken");
    let refreshTokenValue = localStorage.getItem("refreshToken");
    let roleValue = localStorage.getItem("role");
    let loginData = localStorage.getItem("login");

    // If not in localStorage, check sessionStorage (remember me was unchecked)
    if (!accessTokenValue) {
      accessTokenValue = sessionStorage.getItem("accessToken");
      refreshTokenValue = sessionStorage.getItem("refreshToken");
      roleValue = sessionStorage.getItem("role");
      loginData = sessionStorage.getItem("login");
    }

    // Check if tokens exist and are not expired
    if (accessTokenValue && refreshTokenValue && roleValue) {
      const expiryTime =
        localStorage.getItem("accessToken_expiry") ||
        sessionStorage.getItem("accessToken_expiry");

      if (expiryTime && dayjs().isBefore(dayjs(expiryTime))) {
        // Tokens are valid, restore login state
        setAccessToken("accessToken", accessTokenValue, {
          path: "/",
          httpOnly: false,
          expires: dayjs(expiryTime).toDate(),
          secure: true,
          sameSite: "none",
        });
        setAccessToken("refreshToken", refreshTokenValue, {
          path: "/",
          httpOnly: false,
          expires: dayjs(expiryTime).toDate(),
          secure: true,
          sameSite: "none",
        });
        setAccessToken("role", roleValue, {
          path: "/",
          httpOnly: false,
          expires: dayjs(expiryTime).toDate(),
          secure: true,
          sameSite: "none",
        });

        if (loginData) {
          localStorage.setItem("login", loginData);
          dispatch(setLoginState(JSON.parse(loginData)));
        }

        // Navigate based on role
        if (roleValue === "3") {
          navigate("/");
        } else if (roleValue === "2") {
          const userData = loginData ? JSON.parse(loginData) : null;
          if (userData?.channel_count === 1) {
            navigate("/dashboard");
          } else {
            navigate("/account-setup");
          }
        }

        dispatch(resetDialogState());
        return true;
      } else {
        // Tokens expired, clear them
        removeAccessToken("accessToken");
        removeAccessToken("refreshToken");
        removeAccessToken("role");
        removeAccessToken("googleToken");
      }
    }

    return false;
  };

  const CustomRadio = styled(Radio)(({ theme }) => ({
    "&.MuiRadio-root": {
      color: "#999",
    },
    "& .MuiSvgIcon-root": {
      borderRadius: "50%",
      border: "2px solid #999",
      backgroundColor: "#fff",
      width: 20,
      height: 20,
    },
    "&.Mui-checked .MuiSvgIcon-root": {
      borderColor: theme.palette.primary.main,
      backgroundColor: "#fff",
    },
  }));

  const getProfileData = async () => {
    dispatch(setLoading(true));
    try {
      const res = await dispatch(fetchProfileDetails());
      const data = res?.payload;
      dispatch(setProfileState(data));

      // Get user role from localStorage or response
      const userRole = localStorage.getItem("role") || data?.role_id;

      if (userRole === "3") {
        // Business user - go to home page
        navigate("/");
      } else if (userRole === "2") {
        // Creator user - check for channels or Instagram accounts
        const hasChannels = data?.channels && data.channels.length > 0;
        const hasInstaAccounts =
          data?.insta_accounts && data.insta_accounts.length > 0;

        if (hasChannels || hasInstaAccounts) {
          // User has at least one channel or Instagram account, go to dashboard
          navigate("/dashboard");
        } else {
          // User has no channels or Instagram accounts, go to account setup
          navigate("/account-setup");
        }
      }

      dispatch(setLoading(false));
    } catch (error: any) {
      ToastMessage({
        type: "error",
        message: error.error,
      });
      dispatch(setLoading(false));
    }
    setTimeout(() => {
      dispatch(setLoading(false));
    }, 100);
  };

  const onSuccessData = async (response: props) => {
    dispatch(setLoading(true));
    const roleValue = influencerLogin ? 2 : 3;
    const token = {
      role: roleValue,
      token: response?.access_token,
    };

    const responseData = await Axios.post(`${baseURL}/google-login`, token);
    const loginData = responseData?.data;
    if (loginData?.access_token) {
      setAccessTokenWithExpiry(
        "accessToken",
        loginData?.access_token,
        loginData?.expires_in
      );
      setAccessTokenWithExpiry(
        "refreshToken",
        loginData?.refresh_token,
        loginData?.expires_in
      );
      setAccessTokenWithExpiry(
        "googleToken",
        response?.access_token,
        loginData?.expires_in
      );
      setAccessTokenWithExpiry(
        "role",
        loginData.data?.role_id,
        loginData?.expires_in
      );

      // Store login data in appropriate storage
      const currentRememberMe = influencerLogin ? rememberMeInfluencer : rememberMeBusiness;
      const storage = currentRememberMe ? localStorage : sessionStorage;
      storage.setItem("login", JSON.stringify(loginData.data));

      ToastMessage({
        type: "success",
        message: loginData.message,
      });
      dispatch(setLoading(false));
      dispatch(resetDialogState());

      if (roleValue === 3) {
        navigate("/");
      } else if (roleValue === 2) {
        if (loginData?.data?.channel_count === 1) {
          navigate("/dashboard");
        } else {
          navigate("/account-setup");
        }
      }
    } else {
      ToastMessage({
        type: "error",
        message: loginData.message,
      });
      dispatch(setLoading(false));
    }
  };

  const login = useGoogleLogin({
    onSuccess: (res) => onSuccessData(res),
  });

  const validTLDs = [
    "com",
    "org",
    "net",
    "gov",
    "edu",
    "mil",
    "int",
    "eu",
    "us",
    "uk",
    "ca",
    "jp",
    "cn",
    "au",
  ];
  const validTLDRegex = new RegExp(`(${validTLDs.join("|")})$`, "i");
  const schema = yup.object().shape({
    email: yup
      .string()
      .test("valid-email", "Invalid email address", (value) => {
        if (value) {
          const parts = value.split("@");
          if (parts.length === 2) {
            const username = parts[0];
            const domain = parts[1];

            if (
              username === "" ||
              username.startsWith(".") ||
              domain.startsWith(".") ||
              username.includes("..") ||
              domain.includes("..") ||
              domain.startsWith("-") ||
              username.endsWith(".") ||
              !/^[ -~\t\n\r]+$/.test(value)
            ) {
              return false;
            } else if (domain.startsWith("[") && domain.endsWith("]")) {
              const ip = domain.substring(1, domain.length - 1);
              if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(ip)) {
                const parts = ip.split(".");
                for (let part of parts) {
                  if (parseInt(part) < 0 || parseInt(part) > 255) {
                    return false;
                  }
                }
                return true;
              }
            } else if (domain.includes(".")) {
              const domainParts = domain.split(".");
              const tld = domainParts[domainParts.length - 1];

              if (validTLDRegex.test(tld) || tld === "name") {
                return true;
              }
            }
            return false;
          }
          return false;
        }
        return false;
      })
      .required("Email is required"),
    password: yup
      .string()
      .required("Password is required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      ),
  });

  const handleTokenExpiration = () => {
    removeAccessToken("googleToken");
    removeAccessToken("accessToken");
    removeAccessToken("refreshToken");
    removeAccessToken("role");
  };

  useEffect(() => {
    const expirationTimeInSeconds = expireTime ? expireTime : 30;
    const expirationTimeInMilliseconds = expirationTimeInSeconds * 1000;
    const timer = setTimeout(
      handleTokenExpiration,
      expirationTimeInMilliseconds
    );
    return () => {
      clearTimeout(timer);
    };
  }, []);

  // Check for existing login when component mounts
  useEffect(() => {
    checkExistingLogin();
  }, []);

  // Function to update form data based on selected radio button
  const updateFormDataForSide = () => {
    if (!influencerLogin) {
      // Business side
      const email = localStorage.getItem("emailBusiness");
      const password = getEncryptedPassword("passwordBusiness");
      setFormData({
        role: "3",
        email: email || "",
        password: password || "",
      });
    } else {
      // Influencer side
      const email = localStorage.getItem("emailInfluencer");
      const password = getEncryptedPassword("passwordInfluencer");
      setFormData({
        role: "2",
        email: email || "",
        password: password || "",
      });
    }
  };

  // Update form data when influencerLogin state changes and remember me is checked
  useEffect(() => {
    const currentRememberMe = influencerLogin ? rememberMeInfluencer : rememberMeBusiness;
    if (currentRememberMe) {
      updateFormDataForSide();
    }
  }, [influencerLogin, rememberMeBusiness, rememberMeInfluencer]);

  const LoginAPICall = async () => {
    const currentRememberMe = influencerLogin ? rememberMeInfluencer : rememberMeBusiness;
    
    if (currentRememberMe === true) {
      // Save credentials based on current selected side
      if (!influencerLogin) {
        // Business side
        localStorage.setItem("emailBusiness", formData.email);
        storeEncryptedPassword("passwordBusiness", formData.password);
      } else {
        // Influencer side
        localStorage.setItem("emailInfluencer", formData.email);
        storeEncryptedPassword("passwordInfluencer", formData.password);
      }
      // Save the current radio selection
      localStorage.setItem("radioSelectionBusiness", influencerLogin.toString());
    } else {
      // Remove all saved credentials if remember me is unchecked
      localStorage.removeItem("emailBusiness");
      removeEncryptedPassword("passwordBusiness");
      localStorage.removeItem("emailInfluencer");
      removeEncryptedPassword("passwordInfluencer");
      localStorage.removeItem("radioSelectionBusiness");
    }

    setFormErrors({});
    dispatch(setLoading(true));
    try {
      // Updated to use dynamic role based on radio selection
      const updatedFormData = {
        ...formData,
        role: influencerLogin ? "2" : "3",
      };

      const response = await Axios.post(`${baseURL}/login`, updatedFormData);

      if (response?.data?.access_token) {
        ToastMessage({
          type: "success",
          message: response.data.message,
        });
        dispatch(setLoginState(response?.data?.data));
        setExpireTime(response?.data?.expires_in);

        setAccessTokenWithExpiry(
          "accessToken",
          response?.data?.access_token,
          response?.data?.expires_in
        );
        setAccessTokenWithExpiry(
          "refreshToken",
          response?.data?.refresh_token,
          response?.data?.expires_in
        );
        setAccessTokenWithExpiry(
          "role",
          response?.data?.data?.role_id,
          response?.data?.expires_in
        );

        dispatch(resetDialogState());

        // Store login data in appropriate storage
        const currentRememberMe = influencerLogin ? rememberMeInfluencer : rememberMeBusiness;
        const storage = currentRememberMe ? localStorage : sessionStorage;
        storage.setItem("login", JSON.stringify(response?.data?.data));

        dispatch(setLoading(false));
        await getProfileData();
      } else {
        ToastMessage({
          type: "error",
          message: response.data.message,
        });
        dispatch(setLoading(false));
      }
    } catch (error: any) {
      ToastMessage({
        type: "error",
        message: error.message,
      });
      dispatch(setLoading(false));
    }
  };

  const removeAccessToken = (key: any) => {
    localStorage.removeItem(key);
    localStorage.removeItem(`${key}_expiry`);
    sessionStorage.removeItem(key);
    sessionStorage.removeItem(`${key}_expiry`);

    navigate(location?.pathname);
  };

  const setAccessTokenWithExpiry = (
    key: any,
    value: string,
    expiryInSeconds: number
  ) => {
    const options = {
      path: "/",
      httpOnly: false,
      expires: dayjs().add(expiryInSeconds, "seconds").toDate(),
      secure: true,
      sameSite: "none" as "none",
    };

    setAccessToken(key, value, options);

    // Store in localStorage or sessionStorage based on remember me setting
    const currentRememberMe = influencerLogin ? rememberMeInfluencer : rememberMeBusiness;
    const storage = currentRememberMe ? localStorage : sessionStorage;
    storage.setItem(key, value);
    storage.setItem(
      `${key}_expiry`,
      dayjs().add(expiryInSeconds, "seconds").toISOString()
    );

    setTimeout(() => {
      removeAccessToken(key);
    }, expiryInSeconds * 1000);
  };

  const handleLogin = async (e: any) => {
    e.preventDefault();
    schema
      .validate(formData, { abortEarly: false })
      .then(() => {
        LoginAPICall();
      })
      .catch((err) => {
        const errors: any = {};
        err.inner.forEach((e: any) => {
          errors[e.path] = e.message;
        });
        setFormErrors(errors);
      });
  };

  const handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const name = evt.target.name;
    const value = evt.target.value.trim();

    if (formErrors[name as keyof FormErrors]) {
      setFormErrors((prev) => ({
        ...prev,
        [name]: undefined,
      }));
    }

    setFormData({
      ...formData,
      [name]: value,
    });

    // If remember me is checked, save credentials as user types
    const currentRememberMe = influencerLogin ? rememberMeInfluencer : rememberMeBusiness;
    if (currentRememberMe) {
      if (!influencerLogin) {
        // Business side
        if (name === "email") {
          localStorage.setItem("emailBusiness", value);
        } else if (name === "password") {
          storeEncryptedPassword("passwordBusiness", value);
        }
      } else {
        // Influencer side
        if (name === "email") {
          localStorage.setItem("emailInfluencer", value);
        } else if (name === "password") {
          storeEncryptedPassword("passwordInfluencer", value);
        }
      }
    }
  };

  const handleRememberMeChange = (evt: any) => {
    const isChecked = evt.target.checked;
    
    if (!influencerLogin) {
      // Business side
      setrememberMeBusiness(isChecked);
      localStorage.setItem("rememberMeBusiness", isChecked.toString());
    } else {
      // Influencer side
      setRememberMeInfluencer(isChecked);
      localStorage.setItem("rememberMeInfluencer", isChecked.toString());
    }
    
    // If unchecking remember me, also remove saved radio selection and credentials
    if (!isChecked) {
      localStorage.removeItem("radioSelectionBusiness");
      if (!influencerLogin) {
        // Business side
        localStorage.removeItem("emailBusiness");
        removeEncryptedPassword("passwordBusiness");
      } else {
        // Influencer side
        localStorage.removeItem("emailInfluencer");
        removeEncryptedPassword("passwordInfluencer");
      }
    } else {
      // If checking remember me, save current radio selection and credentials
      localStorage.setItem("radioSelectionBusiness", influencerLogin.toString());
      
      // Save current credentials for the selected side
      if (!influencerLogin) {
        // Business side
        localStorage.setItem("emailBusiness", formData.email);
        storeEncryptedPassword("passwordBusiness", formData.password);
      } else {
        // Influencer side
        localStorage.setItem("emailInfluencer", formData.email);
        storeEncryptedPassword("passwordInfluencer", formData.password);
      }
    }
  };

  return (
    <Box sx={{ p: { md: "0 10px", xs: "0 0" } }}>
      <Box
        sx={{
          cursor: "pointer",
          position: "absolute",
          right: { sm: "39px", xs: "20px" },
          top: { sm: "30px", xs: "20px" },
        }}
        onClick={() => {
          dispatch(resetDialogState());
        }}
      >
        <CloseOutlined
          sx={{
            color: "white",
            width: "30px",
            height: "30px",
          }}
        />
      </Box>
      <Box sx={{ width: "100%", maxWidth: "438px", m: "10px auto" }}>
        <Box pt={{ md: 0, xs: "10px" }}>
          <Typography variant="h1">Login</Typography>
        </Box>

        {/* <Box>
          <FormControl component="fieldset" sx={{ mt: 2 }}>
            <RadioGroup
              row
              aria-label="options"
              name="loginOptions"
              value={value}
              onChange={handleRadioChange}
            >
              <FormControlLabel
                value="option1"
                control={<CustomRadio />}
                label="business side"
              />
              <FormControlLabel
                value="option2"
                control={<CustomRadio />}
                label="influencer side"
              />
            </RadioGroup>
          </FormControl>
        </Box> */}
        <Box
          sx={{
            mt: "36px",
          }}
        >
          <TextInput
            title="Email"
            onChange={handleChange}
            value={formData.email || ""}
            name="email"
            placeholder="Enter your email address"
            autoComplete="off"
          />{" "}
          {formErrors.email && (
            <div
              style={{
                color: "red",
                textAlign: "left",
                fontSize: "14px",
                marginTop: "3px",
              }}
            >
              {formErrors.email}
            </div>
          )}
        </Box>
        <Box sx={{ mt: "17px" }}>
          <TextInput
            title="Password"
            name="password"
            onChange={handleChange}
            value={formData.password || ""}
            placeholder="Enter your password"
            type={showPassword ? "text" : "password"}
            autoComplete="new-password"
            EndIcon={
              <IconButton onClick={() => setShowPassword((show) => !show)}>
                {showPassword ? <EyeOn /> : <EyeOff />}
              </IconButton>
            }
          />
          {formErrors.password && (
            <div
              style={{
                color: "red",
                textAlign: "left",
                fontSize: "14px",
                marginTop: "3px",
              }}
            >
              {formErrors.password}
            </div>
          )}
        </Box>

        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          pt={"20px"}
          sx={{
            "& .MuiFormControlLabel-root": {
              mr: "0",
            },
          }}
        >
          <Box>
            <FormControlLabel
              sx={{
                "& .MuiTypography-body1": {
                  color: colors.gray[300],
                  fontStyle: "normal",
                  fontWeight: 400,
                  fontSize: { xs: "14px", sm: "16px" },
                  lineHeight: "1.5",
                },
              }}
              control={
                <Checkbox
                  className="checkbox-custom"
                  sx={{
                    "& span": {
                      width: { xs: "20px", sm: "24px !important" },
                      height: { xs: "20px", sm: "24px !important" },
                    },
                    "& span::before": {
                      width: { xs: "20px !important", sm: "24px !important" },
                      height: { xs: "20px !important", sm: "24px !important" },
                    },
                  }}
                  name="rememberMeBusiness"
                  checkedIcon={<CheckedIcon />}
                  icon={<UnCheckedIcon />}
                  disableRipple
                  checked={influencerLogin ? rememberMeInfluencer : rememberMeBusiness}
                  onChange={handleRememberMeChange}
                />
              }
              label={"Remember me"}
            />
          </Box>
          <Box>
            <Button
              variant="text"
              onClick={() => {
                dispatch(
                  setDialogState({
                    loginDialog: false,
                    registerDialog: false,
                    modal: true,
                    otpDialog: { otpDialog: false, fromPageName: "" },
                    privacyDialog: false,
                    resetPassword: false,
                    successReset: false,
                    termsDialog: false,
                    forgotPassword: true,
                    influencerLogin: false,
                  })
                );
              }}
              sx={{
                color: colors.gray[300],
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: { xs: "14px", sm: "16px" },
                textAlign: { xs: "end", sm: "" },
                lineHeight: "1.5",
                textDecoration: "none",
              }}
            >
              Forgot password?
            </Button>
          </Box>
        </Box>
        <Box pt={"35px"}>
          <Button type="submit" sx={{ width: "100%" }} onClick={handleLogin}>
            Login
          </Button>
        </Box>
        <Box
          sx={{
            pt: "42px",
            "& .MuiDivider-root": {
              "&::before": {
                borderTop: `2px solid ${colors.dark[100]}`,
              },
              "&::after": {
                borderTop: `2px solid ${colors.dark[100]}`,
              },
              "& .MuiDivider-wrapper ": {
                pl: "26px",
                pr: "26px",
              },
            },
          }}
        >
          <Divider sx={{ color: colors.gray[300] }}>or continue with</Divider>
        </Box>
        <Box pt={"30px"}>
          <Button
            onClick={() => {
              login();
            }}
            variant="outlined"
            fullWidth
            sx={{
              color: "white",
              border: `2px solid ${colors.dark[100]}`,
              fontWeight: "500",
            }}
            startIcon={<GoogleIcon />}
          >
            Sign in with google
          </Button>
        </Box>
        <Box
          mt={{ md: "30px", xs: "20px" }}
          mb={{ md: "0", xs: "20px" }}
          textAlign="center"
        >
          <Typography
            variant="body2"
            fontWeight="400"
            lineHeight={"180%"}
            sx={{ color: colors.gray[300] }}
            display={"inline"}
          >
            Don't have an account?{" "}
            <Typography
              sx={{
                color: colors.basics.primary,
                textDecoration: "none",
                cursor: "pointer",
              }}
              display={"inline"}
              variant="body2"
              onClick={() => {
                dispatch(
                  setDialogState({
                    modal: true,
                    registerDialog: true,
                    loginDialog: false,
                    otpDialog: { otpDialog: false, fromPageName: "" },
                    privacyDialog: false,
                    resetPassword: false,
                    successReset: false,
                    termsDialog: false,
                    forgotPassword: false,
                    influencerLogin: influencerLogin,
                  })
                );
              }}
            >
              Sign Up
            </Typography>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default LoginModal;
